import React, {Fragment, useState} from "react";
import {Popover, Transition} from "@headlessui/react";
import {t} from "i18next";
import {useAuth} from "../hooks/useAuth";
import Cookies from "universal-cookie";

export const FlyoutAboutMenu = (props) => {
    const {isAuthenticated} = useAuth();

    const optionsData = [
        {
            title: t("HEADER.ABOUT_MENU.KULVRUTTANT_SAMIITI.TITLE"),
            description: t("HEADER.ABOUT_MENU.KULVRUTTANT_SAMIITI.DESCRIPTION"),
            icon: "/assets/user-group-icon-outlined.svg",
            hoverIcon: "/assets/user-group-icon-filled.svg",
            url: "/kulvruttant-samiti",
            authenticationRequired: false
        },
        {
            title: t("HEADER.ABOUT_MENU.JOGLEKAR_VAATCHAAL.TITLE"),
            description: t("HEADER.ABOUT_MENU.JOGLEKAR_VAATCHAAL.DESCRIPTION"),
            icon: "/assets/vaatchaal-icon-outlined.svg",
            hoverIcon: "/assets/vaatchaal-icon-filled.svg",
            url: "https://jogkulstorageuat.blob.core.windows.net/siteassets/static-pages-base-data/joglekarkul-vatchal.pdf",
            authenticationRequired: false
        },
        {
            title: t("HEADER.ABOUT_MENU.PRESIDENTS_THOUGHTS.TITLE"),
            description: t("HEADER.ABOUT_MENU.PRESIDENTS_THOUGHTS.DESCRIPTION"),
            icon: "/assets/president-icon-outlined.svg",
            hoverIcon: "/assets/president-icon-filled.svg",
            url: "/manogat",
            authenticationRequired: false
        },
        {
            title: t("HEADER.ABOUT_MENU.ANNUAL_REPORTS.TITLE"),
            description: t("HEADER.ABOUT_MENU.ANNUAL_REPORTS.DESCRIPTION"),
            icon: "/assets/annual-reports-icon-outlined.svg",
            hoverIcon: "/assets/annual-reports-icon-filled.svg",
            url: "/annual-reports",
            authenticationRequired: true
        },
        {
            title: t("HEADER.ABOUT_MENU.KULVRUTTANT_COMMITTEE.TITLE"),
            description: t("HEADER.ABOUT_MENU.KULVRUTTANT_COMMITTEE.DESCRIPTION"),
            icon: "/assets/proceedings-icon-outlined.svg",
            hoverIcon: "/assets/proceedings-icon-filled.svg",
            url: "/proceedings",
            authenticationRequired: true
        },
        {
            title: t("HEADER.ABOUT_MENU.STATUS_REGULATION.TITLE"),
            description: t("HEADER.ABOUT_MENU.STATUS_REGULATION.DESCRIPTION"),
            icon: "/assets/statutes-and-regulations-icon-outlined.svg",
            hoverIcon: "/assets/statutes-and-regulations-icon-filled.svg",
            url: "https://jogkulstorageuat.blob.core.windows.net/siteassets/static-pages-base-data/joglekarkul-ghatana-and-by-laws.pdf",
            authenticationRequired: false
        },
        {
            title: t("HEADER.ABOUT_MENU.INFORMATION.TITLE"),
            description: t("HEADER.ABOUT_MENU.INFORMATION.DESCRIPTION"),
            icon: "/assets/information-icon-outlined.svg",
            hoverIcon: "/assets/information-icon-filled.svg",
            url: "/info",
            authenticationRequired: false
        },
        {
            title: t("HEADER.ABOUT_MENU.CONTACT.TITLE"),
            description: t("HEADER.ABOUT_MENU.CONTACT.DESCRIPTION"),
            icon: "/assets/contact-icon-outlined.svg",
            hoverIcon: "/assets/contact-icon-filled.svg",
            url: "/contact",
            authenticationRequired: false
        },
        {
            title: t("HEADER.ABOUT_MENU.MEMBERSHIP.TITLE"),
            description: t("HEADER.ABOUT_MENU.MEMBERSHIP.DESCRIPTION"),
            icon: "/assets/membership-icon-outlined.svg",
            hoverIcon: "/assets/membership-icon-filled.svg",
            url: '/membership',
            authenticationRequired: false
        },
        {
            title: t("HEADER.ABOUT_MENU.SHATAYUSHI.TITLE"),
            description: t("HEADER.ABOUT_MENU.SHATAYUSHI.DESCRIPTION"),
            icon: "/assets/shatayushi-icon-outlined.svg",
            hoverIcon: "/assets/shatayushi-icon-filled.svg",
            url: '/shatayushi-members',
            authenticationRequired: false
        }
    ];

    const {isFlyoutAboutMenuOpen, setIsFlyoutAboutMenuOpen, setIsFlyoutNavigationMenuOpen} = props;
    const [isFlyoutAboutMenuButtonHovered, setIsFlyoutAboutMenuButtonHovered] = useState(false);

    const [hoveredOptionIndex, setHoveredOptionIndex] = useState(null);

    return (
        <div
            className={`portrait:jk:hidden landscape:md:hidden h-fit py-[0.75rem]
                ${isFlyoutAboutMenuButtonHovered && 'bg-black/30'} 
                flex items-center justify-center
                transition ease-in-out duration-150
                relative after:content-[''] after:absolute
                after:right-0 after:bottom-0 after:left-0 after:h-[1.5px] after:bg-[length:10px_1px]
                after:bg-[linear-gradient(90deg,#EEEEE2,#EEEEE2_50%,transparent_0,transparent)]`}
        >
            <Popover className="flex w-full">
                {({}) => {
                    // To prevent the body from scrolling when the popover is isFlyoutAboutMenuOpen
                    document.body.classList.toggle(
                        "overflow-y-hidden",
                        isFlyoutAboutMenuOpen
                    );

                    return (
                        <>
                            <button
                                onMouseEnter={() => setIsFlyoutAboutMenuButtonHovered(true)}
                                onMouseLeave={() => setIsFlyoutAboutMenuButtonHovered(false)}
                                onClick={() => setIsFlyoutAboutMenuOpen(!isFlyoutAboutMenuOpen)}
                                className="arrow-button flex-1 flex items-center justify-between outline-none w-full"
                            >
                                <p
                                    className="font-custom-semi-bold text-gray-900
                                    portrait:text-[1.1rem] portrait:sm:text-[1.3rem]
                                    landscape:text-[1.15rem] landscape:sm:text-[1.25rem]"
                                >
                                    {t("HEADER.ABOUT_MENU.TITLE")}
                                </p>
                                <svg
                                    viewBox="0 0 6 6"
                                    fill="none"
                                    id={"arrow-icon"}
                                    className="aspect-auto
                                    portrait:h-[0.85rem] portrait:sm:h-[1.1rem]
                                    landscape:h-[0.75rem] landscape:sm:h-[0.95rem]"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M3 1L5 3L3 5"
                                        id={"arrow-icon-tip"}
                                        stroke="#111827"
                                        strokeLinecap="square"
                                    />
                                    <path
                                        d="M1 3L4 3"
                                        id={"arrow-icon-line"}
                                        stroke="#111827"
                                        strokeLinecap="square"
                                    />
                                </svg>
                            </button>

                            <Transition
                                show={isFlyoutAboutMenuOpen}
                                as={Fragment}
                                enter="transition ease-out duration-300"
                                enterFrom="opacity-0 translate-x-full"
                                enterTo="opacity-100 translate-x-0"
                                leave="transition ease-in duration-200"
                                leaveFrom="opacity-100 translate-x-0"
                                leaveTo="opacity-0 translate-x-full"
                            >
                                <Popover.Panel
                                    className="fixed z-[10000] flex flex-col bottom-0 left-0
                                    min-w-screen min-h-[100dvh] w-screen h-[100dvh] max-w-screen max-h-[100dvh]"
                                >
                                    <div
                                        className="flex flex-col items-center justify-center
                                        h-full w-full bg-white overflow-hidden"
                                    >
                                        {/* Header */}
                                        <div
                                            className="w-full flex items-center justify-between
                                                portrait:py-[0.5rem] portrait:pl-[1.25rem] portrait:pr-[0.75rem]
                                                portrait:sm:py-[0.75rem] portrait:sm:pl-[1rem] portrait:sm:pr-[0.5rem]
                                                portrait:gap-x-[0.5rem] portrait:sm:gap-x-[0.75rem]
                                                landscape:py-[0.75rem] landscape:pl-[1rem] landscape:pr-[0.75rem]
                                                landscape:gap-x-[0.5rem] landscape:sm:gap-x-[0.75rem]
                                                relative after:content-[''] after:absolute
                                                after:right-0 after:bottom-0 after:left-0 after:h-[1px] after:bg-[length:17px_1px]
                                                after:bg-[linear-gradient(90deg,#EEEEE2,#EEEEE2_50%,transparent_0,transparent)]"
                                        >
                                            {/* Back Button */}
                                            <button
                                                onClick={() => setIsFlyoutAboutMenuOpen(false)}
                                                className="flex items-center
                                                    portrait:gap-x-[0.75rem] portrait:sm:gap-x-[0.75rem]
                                                    landscape:gap-x-[0.5rem] landscape:sm:gap-x-[0.75rem]"
                                            >
                                                <svg
                                                    viewBox="0 0 108 176"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="aspect-square
                                                    portrait:h-[0.75rem] portrait:sm:h-[0.95rem]
                                                    landscape:h-[0.75rem] landscape:sm:h-[0.95rem]"
                                                >
                                                    <path
                                                        d="M88 156L20 88L88 20" stroke="#111827"
                                                        strokeWidth="30"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>

                                                <h1
                                                    key="back-to-main-menu"
                                                    className="flex font-custom-bold text-gray-900 leading-tight
                                                    portrait:text-[1.2rem] portrait:sm:text-[1.5rem]
                                                    landscape:text-[1.1rem] landscape:sm:text-[1.5rem]"
                                                >
                                                    {t("HEADER.BACK")}
                                                </h1>
                                            </button>

                                            {/* Close Icon */}
                                            <button
                                                onClick={() => {
                                                    setIsFlyoutAboutMenuOpen(false);
                                                    setTimeout(() => {
                                                        setIsFlyoutNavigationMenuOpen(false);
                                                    }, 200);
                                                }}
                                                type="button"
                                                className="flex items-center justify-center rounded-lg
                                                    portrait:h-[2rem] portrait:sm:h-[2.5rem]
                                                    landscape:h-[1.5rem] landscape:sm:h-[2.25rem]
                                                    aspect-square bg-transparent hover:bg-gray-200"
                                            >
                                                <img
                                                    className={"h-[85%] aspect-square"}
                                                    src={"/assets/close-icon-dark.svg"}
                                                    alt={"Close"}
                                                    title={"Close"}
                                                />
                                            </button>
                                        </div>

                                        {/* Navigation Links */}
                                        <div
                                            className="h-full w-full flex-1 flex flex-col overflow-y-auto"
                                        >
                                            {optionsData.map((option, index) => (
                                                <button
                                                    key={index}
                                                    onClick={() => {
                                                        if (option.authenticationRequired && !isAuthenticated) {
                                                            new Cookies().set("authRequired", true, {path: '/'});
                                                            window.open('/login', '_self');
                                                        } else {
                                                            window.open(option.url, '_blank');
                                                        }
                                                    }}
                                                >
                                                    <div
                                                        className={`group flex 
                                                            ${hoveredOptionIndex === index && 'bg-gray-200'}
                                                            transition duration-150 ease-[cubic-bezier(0.215,0.61,0.355,1)]
                                                            portrait:py-[0.75rem] portrait:px-[1.25rem]
                                                            landscape:py-[0.75rem] landscape:px-[1.25rem]
                                                            portrait:gap-x-[1rem] landscape:gap-x-[1rem]
                                                            relative after:content-[''] after:absolute
                                                            after:right-0 after:bottom-0 after:left-0
                                                            after:h-[1.5px] after:bg-[length:10px_1px]
                                                            after:bg-[linear-gradient(90deg,#EEEEE2,#EEEEE2_50%,transparent_0,transparent)]`}
                                                        onMouseEnter={() => setHoveredOptionIndex(index)}
                                                        onMouseLeave={() => setHoveredOptionIndex(null)}
                                                        onTouchStart={() => setHoveredOptionIndex(index)}
                                                        onTouchEnd={() => setHoveredOptionIndex(null)}
                                                    >
                                                        <div
                                                            className={`flex items-center justify-center
                                                                portrait:h-[3rem] portrait:sm:h-[3.5rem]
                                                                portrait:p-[0.75rem] portrait:sm:p-[1rem]
                                                                landscape:h-[3rem] landscape:sm:h-[4.25rem]
                                                                landscape:p-[0.75rem] landscape:sm:p-[1.25rem] 
                                                                aspect-square rounded-xl
                                                                ${hoveredOptionIndex === index ? 'bg-orange-400' : 'bg-gray-50'}
                                                                transition duration-150 ease-[cubic-bezier(0.215,0.61,0.355,1)]`}
                                                        >
                                                            <img
                                                                alt={option.title}
                                                                src={hoveredOptionIndex === index ? option.hoverIcon : option.icon}
                                                                className="h-full aspect-square"
                                                            />
                                                        </div>
                                                        <div className={"flex flex-col"}>
                                                            <h1
                                                                className="font-custom-semi-bold leading-tight text-gray-900
                                                                portrait:text-[1rem] portrait:sm:text-[1.25rem]
                                                                landscape:text-[1rem] landscape:sm:text-[1.25rem] text-left"
                                                            >
                                                                {option.title}
                                                            </h1>
                                                            <p
                                                                className="max-w-[75dvw] mt-1
                                                                font-custom-regular leading-tight text-gray-700
                                                                portrait:text-[0.85rem] portrait:sm:text-[1rem]
                                                                landscape:text-[0.85rem] landscape:sm:text-[1rem] text-left"
                                                            >
                                                                {option.description}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                </Popover.Panel>
                            </Transition>
                        </>
                    );
                }}
            </Popover>
        </div>
    )
}
